import React from 'react';

const MapPinIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16.6693 8.33464C16.6693 13.3346 10.0026 18.3346 10.0026 18.3346C10.0026 18.3346 3.33594 13.3346 3.33594 8.33464C3.33594 6.56653 4.03832 4.87083 5.28856 3.62059C6.5388 2.37035 8.23449 1.66797 10.0026 1.66797C11.7707 1.66797 13.4664 2.37035 14.7166 3.62059C15.9669 4.87083 16.6693 6.56653 16.6693 8.33464Z"
      stroke="#616893"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 10.832C11.3807 10.832 12.5 9.71274 12.5 8.33203C12.5 6.95132 11.3807 5.83203 10 5.83203C8.61929 5.83203 7.5 6.95132 7.5 8.33203C7.5 9.71274 8.61929 10.832 10 10.832Z"
      stroke="#616893"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default MapPinIcon;
